<!--
 * @Author: leo.liu
 * @Date: 2021-3-13 11:04:24
 * @Last Modified by:   leo.liu
 * @Last Modified time: 2021-3-13 11:04:24
 !-->
<template>
  <div class="account-select">
    <div class="all-btn">
      <a-button type="text" class="theme-link-btn" @click="checkAll">全选</a-button>            
      <a-tooltip placement="topLeft" title="全选指选中当前下拉框中的账号,最多50个" v-if="isAccount">
        <a-icon type="question-circle"/>
      </a-tooltip>
    </div>
    <div class="clear-btn" :class="isAccount?'is-account':''">
      <a-button type="text" class="theme-link-btn " @click="updateValue([])">清空</a-button>
      <a-tooltip placement="topLeft" title="清空状态下,默认查询有权限的所有账号" v-if="isAccount">
        <a-icon type="question-circle"/>
      </a-tooltip>
    </div>
    <span class="account-sum">共{{value.length}}个</span>
    <a-select
      v-model="account"
      mode="multiple"
      :filter-option="false"
      :maxTagCount="1"
      :maxTagTextLength="6"
      placeholder="请下拉进行选择或者输入"
      @change="changeAccount"
      @search="(v) => $emit('search', v)"
      :dropdownMatchSelectWidth="false"
      dropdownClassName="account-select-dropdown"
    >
      <a-spin tip="正在查询中" v-if="loading" slot="notFoundContent" size="small" style="width:100%"/>
      <a-select-option
        v-for="item in accountList"
        :key="item.id"
        :value="item.id"
        :class="value.indexOf(item.id) > -1?'selected':''"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <div class="account-tag">
      <div class="account-tags" 
        @mouseenter="hoverFlag = i" @mouseleave="hoverFlag = null"
        v-for="(v,i) in value" :key="v"
      >
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{ accountName(v) }}</span>
          </template>
          <span>{{ accountName(v) }}</span>
        </a-tooltip>
        <a-icon @click="close(i)" type="close-circle" class="close" v-if="hoverFlag === i"></a-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountSelect",
  components: {},
  props: {
    value: Array,
    accountList: Array,
    datasource: String,
    dataDimensionType: String,
    loading: Boolean,
    isAccount: Boolean
  },
  data() {
    return {
      account: [],
      hoverFlag: null,
      accountCache: []
    };
  },
  watch: {
    accountList: {
      handler(val) {
        let arr = val.filter(v => !this.accountCache.find(value => value.id === v.id))
        this.accountCache = this.accountCache.concat(arr)
      },
      deep: true
    },
    dataDimensionType(val) {
      console.log(val, 'dataDimensionType');
    }
  },
  mounted() {
  },
  methods: {
    checkAll() {
      let arr = [...this.accountList.map(v => v.id), ...this.value]
      this.updateValue(Array.from(new Set(arr)))
    },
    changeAccount(v) {
      let i = this.value.indexOf(v[0])
      if(i === -1) {
        this.updateValue([...this.value, v[0]])
      } else {
        let v = this.$deepclone(this.value)
        v.splice(i, 1)
        this.updateValue(v)
      }
      this.account = []
    },
    updateValue(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    accountName(v) {
      let obj =  this.accountCache.find(val => val.id === v)
      return obj?.name || v
    },
    close(i) {
      let arr = JSON.parse(JSON.stringify(this.value))
      arr.splice(i, 1)
      this.updateValue(arr)
    }
  }
};
</script>

<style scoped lang="less">
.account-select {
  position: relative;
  .clear-btn,.all-btn,.account-sum {
    position: absolute;
    z-index: 100;
    font-size: 12px;
    right: 5px;
    top: -34px;
  }
  .account-sum{
    top: 7px;
  }
  .clear-btn {
    right: 33px;
    .anticon {
      margin-left: 2px;
    }
    &.is-account {
      right: 48px;
    }
  }
  .all-btn {
    right: 3px;
    .anticon {
      margin-left: 2px;
    }
  }
}
.account-tag {
  margin-top: 8px;
}
.account-tags {
  height: 22px;
  background: #F3F6FE;
  border-radius: 4px 4px 4px 4px;
  display: inline-block;
  margin-right: 4px;
  margin-bottom: 4px;
  text-align: center;
  padding: 0 8px;
  line-height: 22px;
  font-size: 12px;
  font-weight: 400;
  color: #677392;
  position: relative;
  white-space: nowrap;
  text-overflow:ellipsis;
  overflow:hidden;
  max-width: calc(100% - 4px);
  .close {
    background: #9CA9CB;
    font-size: 14px;
    position: absolute;
    top: 4px;
    right: 4px;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
  }
}
</style>
<style lang="less">
  .ant-select-dropdown.ant-select-dropdown--multiple {
    .selected {
      .ant-select-selected-icon {
        display: inline-block;
        color: #22ac35;
      }
    }
  }
  .account-select-dropdown {
    left: auto!important;
    right: 56px!important;
  }
</style>
